<div class="row">
  <div class="col-lg-4 col-sm-12">
    <label class="form-label title-blue-bimbo-cap">Año</label>

    <select
      class="form-select"
      [disabled]="disabled"
      [(ngModel)]="selectedYear"
      (ngModelChange)="onYearChange($event)">
      <option [ngValue]="null" disabled>Selecciona un año</option>

      <option *ngFor="let year of yearList" [ngValue]="year.id">
        {{ year.nombre }}
      </option>
    </select>
  </div>

  <div class="col-lg-8 col-sm-12">
    <label class="form-label title-blue-bimbo-cap">Sesión</label>
    <ng-container *ngIf="isLoadingSessions; else sessionSelect">
      <app-skeleton skeletonType="skeleton-input-sm"></app-skeleton>
    </ng-container>

    <ng-template #sessionSelect>
      <select
        class="form-select"
        [disabled]="disabled || !selectedYear"
        [(ngModel)]="selectedSessionId"
        (ngModelChange)="onSessionChange($event)"
        (blur)="onSessionBlur()">
        <option [ngValue]="null" disabled>Selecciona una sesión</option>

        <option *ngIf="sessions.length === 0" disabled>
          Sin sesiones para mostrar
        </option>

        <option *ngFor="let session of sessions" [ngValue]="session.Id">
          {{ session.IdLocalizador }} - {{ session.titulo }}
        </option>
      </select>

      <span class="form-text text-danger" *ngIf="showSessionError">
        Selecciona una sesión
      </span>
    </ng-template>
  </div>
</div>
